<template>
    <div id="main">
        <sek-header class="is-scrolled"/>
        <div id="wrapper">
            <section id="cadastro">
                <div class="box">
                    <h2 
                        class="cadastro-title text-center white--text mb-0">
                        Cadastro
                    </h2>
                    <h5 class="cadastro-subtitle white--text text-center">
                        cadastro de assessorados
                    </h5>

                    <v-text-field
                        label="E-mail" 
                        dark
                        color="#ff8800"
                        v-model="email" />
                    <v-text-field
                        type="password"
                        label="Senha" 
                        dark
                        color="#ff8800"
                        v-model="password" />

                    <div class="d-flex">
                        <v-btn
                            class="mx-auto cadastro-btn"
                            color="#ff8800">
                            Cadastrar
                        </v-btn>

                    </div>

                    <p class="white--text text-center mt-8">Já é um membro? <span style="color: #ff8800;">Login</span></p>
                </div>
            </section>
        </div>
        <sek-footer>
            <div></div>
        </sek-footer>
    </div>
</template>

<script>
import Header from '../../components/base/Header.vue'
import Footer from '../../components/base/Footer.vue'

export default {
    components: {
        'sek-header': Header,
        'sek-footer': Footer
    },
    data() {
        return {
            password: "",
            email: ""
        }
    },
    methods: {
        
    },
}
</script>

<style lang="scss">
#main {
    height: 100%;
    display: flex;
    flex-direction: column;

    #wrapper {
        width: 100%;
        height: 100%;

        #cadastro {
            min-height: 768px;
            background-image: url('~@/assets/images/sek-section-bg.png');
            background-position: center 30%;
            background-size: cover;
            display: flex;
            align-items: center;
            justify-content: center;

            .box {
                min-width: 300px;
                width: 25vw;
                border-radius: 7px;
                background: black;  
                box-shadow: 0px 0px 10px 5px #ff8801;
                padding: 20px 70px;

                .cadastro-title {
                    font-size: 45px;
                    line-height: 45px;
                    margin-top: 40px;
                }

                .cadastro-subtitle {
                    font-size: 25px;
                    margin-bottom: 30px;
                }

                .cadastro-btn {
                    margin-top: 20px;
                    border-radius: 50px;
                    color: white;
                    text-transform: capitalize;
                    padding: 0 40px;
                }
            }
        }
    }

    // @media screen and (max-width: 480px) {
    //     #wrapper {
    //         padding: 108px 28px 28px 28px;
    //     }
    // }
}
</style>